import React from 'react';
import styled from 'styled-components';
import { LoadingOutlined } from '@ant-design/icons';

const Container = styled.div`
  background-color: #f0f2f5;
  border-radius: 8px;
  padding: 2rem;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin: 1rem 0;
`;

const Title = styled.h3`
  color: #1890ff;
  margin-bottom: 1rem;
`;

const Description = styled.p`
  color: #666;
  margin-bottom: 1.5rem;
`;

const IconWrapper = styled.div`
  font-size: 2rem;
  color: #1890ff;
  margin-bottom: 1rem;
`;

interface ComingSoonProps {
  title?: string;
  description?: string;
}

const ComingSoon: React.FC<ComingSoonProps> = ({
  title = '内容准备中',
  description = '精彩内容即将呈现，敬请期待...',
}) => {
  return (
    <Container>
      <IconWrapper>
        <LoadingOutlined spin />
      </IconWrapper>
      <Title>{title}</Title>
      <Description>{description}</Description>
    </Container>
  );
};

export default ComingSoon; 